import React from "react";
import "../CardNavigation/CardNavigation.css";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";

function CardNavigation({ children, order, setOrder, maxOrder }) {
  const getNextCard = () => {
    if (order === maxOrder) {
      return;
    } else {
      setOrder(order + 1);
    }
  };

  const getPreviousCard = () => {
    if (order === 0) {
      return;
    } else {
      setOrder(order - 1);
    }
  };

  return (
    <div className="card-container">
      <div className="back-container">
        <button
          className={order === 0 ? "btn not-active" : "btn"}
          onClick={() => getPreviousCard()}
        >
          <MdArrowBackIos />
        </button>
      </div>
      <div>{children}</div>
      <div className="next-container">
        <button
          className={order === maxOrder ? "btn not-active" : "btn"}
          onClick={() => getNextCard()}
        >
          <MdArrowForwardIos />
        </button>
      </div>
    </div>
  );
}

export default CardNavigation;
